export enum LevelOfSchooling {
  Preschool = 'preschool',
  ElementarySchool = 'elementary-school',
  HighSchool = 'high-school',
  Adults = 'adults',
  ProfessionalTraining = 'professional-training',
  Other = 'other',
}
